// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__Ii3EJ","childrenContainer":"Page_childrenContainer__mp7MH","noSpacingBottom":"Page_noSpacingBottom__3kftM"};